export default __webpack_public_path__ + "static/media/rewardsSvg.041c4105.svg";